import { translateKey as t } from "../../../../../../locales/translation";

interface cellProps {
  field: string;
  type: string;
  unique: boolean;
  minValue: number;
  maxValue: number;
  mandatory: boolean;
  //----------------------
  atLeastOne: boolean;
  // optional: boolean;
  autoGenerated: boolean;
}

function getDataSet(dataSetType) {
  const vehiclesData = [];
  const depotsData = [
    { label: t("lblDepotRef", "Depot Ref"), value: "", default: "" },
    { label: t("lblName", "Name"), value: "", default: "" },
    { label: t("lblBrandingProfile", "Branding Profile"), value: "", default: "" },
    { label: t("lblType", "Type"), value: "", default: "" },
    { label: t("lblActive", "Active"), value: "", default: "" },
    // { label: t("lblRouteGroup", "Route Group"), value: "", default: "" },
    { label: t("lblHouseNumber", "House Number"), value: "", default: "" },
    { label: t("lblHouseName", "House Name"), value: "", default: "" },
    { label: t("lblAddress1", "Address 1"), value: "", default: "" },
    { label: t("lblAddress2", "Address 2"), value: "", default: "" },
    { label: t("lblAddress3", "Address 3"), value: "", default: "" },
    { label: t("lblAddress4", "Address 4"), value: "", default: "" },
    { label: t("lblLocality", "Locality"), value: "", default: "" },
    { label: t("lblRegion", "Region"), value: "", default: "" },
    { label: t("lblPostCode", "Post Code"), value: "", default: "" },
    { label: t("lblCountryCode", "Country Code"), value: "", default: "" },
    { label: t("lblCountryName", "Country Name"), value: "", default: "" },
    { label: t("lblCoordinatesX", "Coordinates X"), value: "", default: "" },
    { label: t("lblCoordinatesY", "Coordinates Y"), value: "", default: "" },

    { label: t("lblContactsFirstName", "Contacts First Name"), value: "", default: "" },
    { label: t("lblContactsLastName", "Contacts Last Name"), value: "", default: "" },
    { label: t("lblContactsLastName", "Contacts Last Name"), value: "", default: "" },
    { label: t("lblAlertRecipient", "Alert Recipient"), value: "", default: "" },

    { label: t("lblEmailAddress", "Email Address"), value: "", default: "" },
    { label: t("lblEmailLabel", "Email Label"), value: "", default: "" },

    { label: t("lblNumber", "Number"), value: "", default: "" },
    { label: t("lblNumberLabel", "Number Label"), value: "", default: "" },

    { label: t("lblClient", "Client"), value: "", default: "" },
  ];

  const driversData = [
    { label: t("lblCrewRef", "Crew Ref"), value: "", default: "" },
    { label: t("lblFirstName", "First Name"), value: "", default: "" },
    { label: t("lblLastName", "Last Name"), value: "", default: "" },
    { label: t("lblSkillProfile", "Skill Profile"), value: "", default: "" },
    { label: t("lblActive", "Active"), value: "", default: "" },
    { label: t("lblDepot", "Depot"), value: "", default: "" },
    { label: t("lblAlternativeDepots", "Alternative Depots"), value: "", default: "" },
    { label: t("lblContactNo", "ContactNo"), value: "", default: "" },
    { label: t("lblEmail", "Email"), value: "", default: "" },
    { label: t("lblClient", "Client"), value: "", default: "" },
    { label: t("lblFranchisee", "Franchisee"), value: "", default: "" },
    { label: t("lblCompanyFranchisee", "Company Franchisee"), value: "", default: "" },
  ];

  //------------------------------------------------------------------

  const driversTypesData = [];
  const skillsData = [];
  const driverPayGroupsData = [
    {
      label: t("lblDriverPayGroupRef", "Driver Pay Group Ref"),
      value: "",
      default: "",
    },
    {
      label: t("lblDescription", "Description"),
      value: "",
      default: "",
    },
    {
      label: t("lblRates", "Rates"),
      value: "",
      default: "",
    },
    {
      label: t("lblDayOfWeek", "Day Of Week"),
      value: "",
      default: "",
    },
    {
      label: t("lblPayRate", "Pay Rate"),
      value: "",
      default: "",
    },
    {
      label: t("lblId", "Id"),
      value: "",
      default: "",
    },
  ];

  const vehicleTypesData = [
    { label: t("lblVehicleTypeRef", "Vehicle Type Ref"), value: "", default: "" },
    { label: t("lblDescription", "Description"), value: "", default: "" },
    { label: t("lblMaxVolume", "Max Volume"), value: "", default: "" },
    { label: t("lblMaxWeight", "Max Weight"), value: "", default: "" },
    { label: t("lblMaxStops", "MaxS tops"), value: "", default: "" },
    { label: t("lblMaxItems", "Max Items"), value: "", default: "" },
    { label: t("lblStandingCostPerDay", "Standing Cost Per Day"), value: "", default: "" },
    { label: t("lblCostPerKm", "Cost Per Km"), value: "", default: "" },
    { label: t("lblDrivingBreak", "Driving Break"), value: "", default: "" },
    { label: t("lblDrivingBreakSettings", "Driving Break Settings"), value: "", default: "" },
    { label: t("lblMaxSpeedKmh", "Max Speed Kmh"), value: "", default: "" },
    { label: t("lblVehicleWeight", "Vehicle Weight"), value: "", default: "" },
    { label: t("lblVehicleAxleWeight", "Vehicle Axle Weight"), value: "", default: "" },
    { label: t("lblVehicleLength", "Vehicle Length"), value: "", default: "" },
    { label: t("lblVehicleWidth", "Vehicle Width"), value: "", default: "" },
    { label: t("lblVehicleHeight", "Vehicle Height"), value: "", default: "" },
    { label: t("lblPhysicalMaxVolume", "Physical Max Volume"), value: "", default: "" },
    { label: t("lblPhysicalMaxWeight", "Physical Max Weight"), value: "", default: "" },
    { label: t("lblCargoAreaDimensionsEnabled", "Cargo Area Dimensions Enabled"), value: "", default: "" },
    { label: t("lblMaxCargoAreaWidth", "Max Cargo Area Width"), value: "", default: "" },
    { label: t("lblMaxCargoAreaLength", "Max Cargo Area Length"), value: "", default: "" },
    { label: t("lblMaxCargoAreaHeight", "Max Cargo Area Height"), value: "", default: "" },
    { label: t("lblTailLift", "Tail Lift"), value: "", default: "" },
    { label: t("lblSideLift", "Side Lift"), value: "", default: "" },
    { label: t("lblVolumeConstraint", "Volume Constraint"), value: "", default: "" },
    { label: t("lblWeightConstraint", "Weight Constraint"), value: "", default: "" },
    { label: t("lblStopCountConstraint", "Stop Count Constraint"), value: "", default: "" },
    { label: t("lblItemCountConstraint", "Item Count Constraint"), value: "", default: "" },
    { label: t("lblSygicTruck", "Sygic Truck"), value: "", default: "" },
    { label: t("lblVehicleInspectionFormRef", "Vehicle Inspection Form Ref"), value: "", default: "" },
    { label: t("lblCrane", "Crane"), value: "", default: "" },
    { label: t("lblVehicleInspectionEnabled", "Vehicle Inspection Enabled"), value: "", default: "" },
  ];

  const driverPayRatesData = [
    { label: t("lblDriverPayRateRef", "Driver Pay Rate Ref"), value: "", default: "" },
    { label: t("lblDescription", "Description"), value: "", default: "" },
    { label: t("lblBasicRate", "Basic Rate"), value: "", default: "" },
    { label: t("lblMinHoursPaid", "Min Hours Paid"), value: "", default: "" },
    { label: t("lblClient", "Client"), value: "", default: "" },
    { label: t("lblOvertimeRate", "Overtime Rate"), value: "", default: "" },
  ];

  const knownLocationsData = [
    { label: t("lblLocationRef", "Location Ref"), value: "", default: "" },
    { label: t("lblName", "Name"), value: "", default: "" },
    { label: t("lblDescription", "Description"), value: "", default: "" },
    { label: t("lblActive", "Active"), value: "", default: "" },
    { label: t("lblKnownLocationTypeRef", "Known Location Type Ref"), value: "", default: "" },
    { label: t("lblAlternateLocations", "Alternate Locations"), value: "", default: "" },
    { label: t("lblAssociatedDepots", "Associated Depots"), value: "", default: "" },
    { label: t("lblAddress", "Address"), value: "", default: "" },
    { label: t("lblHouseNumber", "House Number"), value: "", default: "" },
    { label: t("lblHouseName", "House Name"), value: "", default: "" },
    { label: t("lblAddress1", "Address1"), value: "", default: "" },
    { label: t("lblAddress2", "Address2"), value: "", default: "" },
    { label: t("lblAddress3", "Address3"), value: "", default: "" },
    { label: t("lblAddress4", "Address4"), value: "", default: "" },
    { label: t("lblLocality", "Locality"), value: "", default: "" },
    { label: t("lblRegion", "Region"), value: "", default: "" },
    { label: t("lblPostCode", "Post Code"), value: "", default: "" },
    { label: t("lblCountryCode", "Country Code"), value: "", default: "" },
    { label: t("lblCountryName", "Country Name"), value: "", default: "" },
    { label: t("lblAddressFlat", "Address Flat"), value: "", default: "" },
    { label: t("lblLocation", "Location"), value: "", default: "" },
    { label: t("lblType", "Type"), value: "", default: "" },
    { label: t("lblCoordinates", "Coordinates"), value: "", default: "" },
    { label: t("lblOpeningHours", "Opening Hours"), value: "", default: "" },
    { label: t("lblPlanningRules", "Planning Rules"), value: "", default: "" },
    { label: t("lblLocationTypeOverrides", "Location Type Overrides"), value: "", default: "" },
    { label: t("lblRisks", "Risks"), value: "", default: "" },
    { label: t("lblContacts", "Contacts"), value: "", default: "" },
    { label: t("lblCustomFields", "Custom Fields"), value: "", default: "" },
    { label: t("lblIsSynced", "Is Synced"), value: "", default: "" },
  ];

  const productCategoriesData = [
    {
      label: t("lblSkillGroupRef", "Skill Group Ref"),
      value: "",
      default: "",
    },
    {
      label: t("lblName", "Name"),
      value: "",
      default: "",
    },
    {
      label: t("lblRank", "Rank"),
      value: "",
      default: "",
    },
    {
      label: t("lblShortRef", "Short Ref"),
      value: "",
      default: "",
    },
    {
      label: t("lblRestricted", "Restricted"),
      value: "",
      default: "",
    },
    {
      label: t("lblParent", "Parent"),
      value: "",
      default: "",
    },
    {
      label: t("lblType", "Type"),
      value: "",
      default: "",
    },
    {
      label: t("lblCategory", "Category"),
      value: "",
      default: "",
    },
    {
      label: t("lblSkills", "Skills"),
      value: "",
      default: "",
    },
    {
      label: t("lblClient", "Client"),
      value: "",
      default: "",
    },
  ];

  const productSkillsData = [
    {
      label: t("lblProduct", "Product"),
      value: "",
      default: "",
    },
    {
      label: t("lblProductCategory", "Product Category"),
      value: "",
      default: "",
    },
    {
      label: t("lblServices", "Services"),
      value: "",
      default: "",
    },
  ];

  const productData = [
    {
      label: t("lblProductRef", "Product Ref"),
      value: "",
      default: "",
    },
    {
      label: t("lblLengthMillimeters", "Length Millimeters"),
      value: "",
      default: "",
    },
    {
      label: t("lblWidthMillimeters", "Width Millimeters"),
      value: "",
      default: "",
    },
    {
      label: t("lblDepthMillimeters", "Depth Millimeters"),
      value: "",
      default: "",
    },
    {
      label: t("lblWeightKg", "Weight Kg"),
      value: "",
      default: "",
    },
    {
      label: t("lblName", "Name"),
      value: "",
      default: "",
    },
    {
      label: t("lblStackable", "Stackable"),
      value: "",
      default: "",
    },
    {
      label: t("lblStackableSettings", "Stackable Settings"),
      value: "",
      default: "",
    },
    {
      label: t("lblStackGroup", "Stack Group"),
      value: "",
      default: "",
    },
    {
      label: t("lblStackHeightMultiplier", "Stack Height Multiplier"),
      value: "",
      default: "",
    },
    {
      label: t("lblMaxStackQuantity", "Max Stack Quantity"),
      value: "",
      default: "",
    },
    {
      label: t("lblAllowCreationFromMobile", "Allow Creation From Mobile"),
      value: "",
      default: "",
    },
    {
      label: t("lblProductCategory", "Product Category"),
      value: "",
      default: "",
    },
    {
      label: t("lblClient", "Client"),
      value: "",
      default: "",
    },
  ];

  const resourceProfileData = [
    {
      label: t("lblResourceCategory", "Resource Category"),
      value: "",
      default: "",
    },
    {
      label: t("lblResourceProfileRef", "Resource Profile Ref"),
      value: "",
      default: "",
    },
    {
      label: t("lblName", "Name"),
      value: "",
      default: "",
    },
    {
      label: t("lblDescription", "Description"),
      value: "",
      default: "",
    },
    {
      label: t("lblDriverType", "Driver Type"),
      value: "",
      default: "",
    },
    {
      label: t("lblVehicleType", "Vehicle Type"),
      value: "",
      default: "",
    },
    {
      label: t("lblMandatoryLoading", "Mandatory Loading"),
      value: "",
      default: "",
    },
    {
      label: t("lblMandatoryUnloading", "Mandatory Unloading"),
      value: "",
      default: "",
    },
    {
      label: t("lblMandatoryCrewPersonnel", "Mandatory Crew Personnel"),
      value: "",
      default: "",
    },
    {
      label: t("lblDriverTypeRef", "Driver Type Ref"),
      value: "",
      default: "",
    },
    {
      label: t("lblVehicleTypeRef", "Vehicle Type Ref"),
      value: "",
      default: "",
    },
    {
      label: t("lblMaxCrewPersonnel", "Max Crew Personnel"),
      value: "",
      default: "",
    },
  ];

  const skillGroupsData = [
    {
      label: t("lblCategory", "Category"),
      value: "",
      default: "",
    },
    {
      label: t("lblName", "Name"),
      value: "",
      default: "",
    },
    {
      label: t("lblOverride", "Override"),
      value: "",
      default: "",
    },
    {
      label: t("lblParent", "Parent"),
      value: "",
      default: "",
    },
    {
      label: t("lblPriority", "Priority"),
      value: "",
      default: "",
    },
    {
      label: t("lblRank", "Rank"),
      value: "",
      default: "",
    },
    {
      label: t("lblRestricted", "Restricted"),
      value: "",
      default: "",
    },
    {
      label: t("lblSkillGroupRef", "Skill Group Ref"),
      value: "",
      default: "",
    },
    {
      label: t("lblSkills", "Skills"),
      value: "",
      default: "",
    },
    {
      label: t("lblType", "Type"),
      value: "",
      default: "",
    },
  ];

  const skillProfilesData = [
    {
      label: t("lblDescription", "Description"),
      value: "",
      default: "",
    },
    {
      label: t("lblSkillGroups", "Skill Groups"),
      value: "",
      default: "",
    },
    {
      label: t("lblSkillProfileRef", "Skill Profile Ref"),
      value: "",
      default: "",
    },
  ];

  const usersData = [
    {
      label: t("lblActive", "Active"),
      value: "",
      default: "",
    },
    {
      label: t("lblDepots", "Depots"),
      value: "",
      default: "",
    },
    {
      label: t("lblEmail", "Email"),
      value: "",
      default: "",
    },
    {
      label: t("lblFirstName", "First Name"),
      value: "",
      default: "",
    },
    {
      label: t("lblLastName", "Last Name"),
      value: "",
      default: "",
    },
    {
      label: t("lblProvider", "Provider"),
      value: "",
      default: "",
    },
    {
      label: t("lblRoles", "Roles"),
      value: "",
      default: "",
    },
    {
      label: t("lblUsername", "Username"),
      value: "",
      default: "",
    },
  ];

  switch (dataSetType) {
    case "depotsTab":
      return depotsData;
    case "driversTab":
      return driversData;
    case "vehiclesTab":
      return vehiclesData;
    case "multiCsvTab":
      return [];
  }
}

function getNewDataSet(dataSetType) {
  const Depots: cellProps[] = [
    { field: "DepotRef", type: "String(20)", unique: true, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "HouseNumber", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "HouseName", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "Address1", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "Address2", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "Address3", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "Address4", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "PostCode", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "CountryCode", type: "String(5)", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Latitude", type: "Decimal", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Longitude", type: "Decimal", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Emails", type: "List[String(50)]", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "ContactNumbers", type: "List[String(50)]", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "BrandingProfile", type: "Select", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "BrandingProfileRef", type: "String", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: true },
  ];

  const ProductHierarchy: cellProps[] = [
    { field: "CategoryRef", type: "String", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Description", type: "String", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "Tier", type: "String", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Parent", type: "String", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "TierRef", type: "String", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: true },
  ];

  const Products: cellProps[] = [
    { field: "ProductRef", type: "String(20)", unique: true, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(30)", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Description", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "Weight(kg)", type: "Decimal", unique: false, minValue: 0, maxValue: 999999, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Length(mm)", type: "Decimal", unique: false, minValue: 0, maxValue: 999999, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Width(mm)", type: "Decimal", unique: false, minValue: 0, maxValue: 999999, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Depth(mm)", type: "Decimal", unique: false, minValue: 0, maxValue: 999999, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "ProductSubCategory", type: "String", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "CreateFromMobile", type: "Boolean", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "ProductSubCategoryRef", type: "String", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: true },
  ];

  const ServiceTypes: cellProps[] = [
    { field: "ServiceTypeRef", type: "String(20)", unique: true, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Description", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "Collection", type: "Boolean", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "Delivery", type: "Boolean", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "Service", type: "Boolean", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: true, autoGenerated: false },
    { field: "Loading", type: "Boolean", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "CreateFromMobile", type: "Boolean", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
  ];

  const Skills: cellProps[] = [
    { field: "SkillRef", type: "String(20)", unique: true, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Description", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
  ];

  const SkillGroups: cellProps[] = [
    { field: "SkillGroupRef", type: "String(20)", unique: true, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Description", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: false, atLeastOne: false, autoGenerated: false },
    { field: "Skillset", type: "String(100)", unique: false, minValue: null, maxValue: null, mandatory: true, atLeastOne: false, autoGenerated: false },
    { field: "Rank", type: "Integer", unique: true, minValue: 1, maxValue: 9999, mandatory: true, atLeastOne: false, autoGenerated: false },
  ];

  const SkillProfiles: cellProps[] = [
    { field: "SkillProfileRef", type: "String(20)", unique: true, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Description", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "SkillGroupsCore", type: "String(100)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "SkillGroupsNonCore", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
  ];

  const ProductServiceSkillTime: cellProps[] = [
    //Need to look into this
    { field: "CategoryTop", type: "Selection", unique: true, mandatory: false, minValue: null, maxValue: null, atLeastOne: true, autoGenerated: false },
    { field: "CategoryMiddle", type: "Selection", unique: true, mandatory: false, minValue: null, maxValue: null, atLeastOne: true, autoGenerated: false },
    { field: "CategoryBottom", type: "Selection", unique: true, mandatory: false, minValue: null, maxValue: null, atLeastOne: true, autoGenerated: false },
    { field: "Product", type: "Selection", unique: true, mandatory: false, minValue: null, maxValue: null, atLeastOne: true, autoGenerated: false },
    //The above neeed to be a combiantion togethe rto be unique

    { field: "ServiceType", type: "Selection", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Skill", type: "Selection", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Minimum Items", type: "Integer", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "Maximum Items", type: "Integer", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "Base Stop Time", type: "Integer", unique: false, mandatory: true, minValue: 0, maxValue: 1440, atLeastOne: false, autoGenerated: false },
    { field: "Additional Stop Time", type: "Integer", unique: false, mandatory: true, minValue: 0, maxValue: 1440, atLeastOne: false, autoGenerated: false },

    { field: "CategoryTopRef", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
    { field: "CategoryMiddleRef", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
    { field: "CategoryBottomRef", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
    { field: "ProductRef", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
    { field: "ServiceTypeRef", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
    { field: "SkillRef", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
  ];

  const VehicleTypes: cellProps[] = [
    //in the excel there are 2 columns updateable
    { field: "VehicleTypeRef", type: "String(20)", unique: true, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "InspectionTemplate", type: "Selection", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "VolumeConstraint[Flag]", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "MaxVolume", type: "Integer", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "WeightConstraint[Flag]", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "MaxWeight", type: "Integer", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "StopCountConstraint[Flag]", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "MaxStops", type: "Integer", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "ItemCountConstraint[Flag]", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "MaxItems", type: "Integer", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "StandingCostPerDay", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "CostPerKm", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "DrivingBreak[Flag]", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "DrivingIntervalHours", type: "Decimal", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "DrivingIntervalDurationHours", type: "Decimal", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "MaxSpeedKmh", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "VehicleWeight", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "VehicleAxleWeight", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "VehicleHeight(m)", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "VehicleLength(m)", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "VehicleWidth(m)", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "PhysicalMaxVolume", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "PhysicalMaxWeight", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "SpecificCargoDimensions", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "CargoSpaceWidth", type: "Decimal", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "CargoSpaceLength", type: "Decimal", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "CargoSpaceHeight", type: "Decimal", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "Tail-lift?", type: "Boolean", unique: false, mandatory: false, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "Side-Lift?", type: "Boolean", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Crane", type: "Boolean", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "SygicTruck", type: "Boolean", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
  ];

  const PayRates: cellProps[] = [
    { field: "ResourcePayRateRef", type: "String(20)", unique: true, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "BasicRate", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "OvertimeRate", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "MinHoursPaid", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
  ];

  const PayGroups: cellProps[] = [
    //Need to look into here
    { field: "ResourcePayGroupRef", type: "String(20)", unique: true, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
  ];

  const DriverTypes: cellProps[] = [
    //Need to look into here
    { field: "DriverTypeRef", type: "String(20)", unique: true, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Rank", type: "Integer", unique: false, mandatory: true, minValue: -999999, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "DutyStartTime", type: "Time", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false }, //here need to figure out how to save time
    { field: "DutyDurationHours", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "DutyBreak[Flag]", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "DutyIntervalHours", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "DutyIntervalDurationHours", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "FixedBreak[Flag]", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "FixedBreakTime", type: "Time", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false }, //here need to figure out how to save time

    { field: "FixedBreakDurationHours", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "BriefDurationHours", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "VariableBriefing", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "BriefingItemsPerHour", type: "Integer", unique: false, mandatory: true, minValue: 1, maxValue: 20000, atLeastOne: false, autoGenerated: false },
    { field: "DeBriefDurationHours", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "MaxOvertimeHours", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "MultiTripping[Flag]", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },

    { field: "MultiTripDepotDuration", type: "Integer", unique: false, mandatory: true, minValue: 0, maxValue: 999999, atLeastOne: false, autoGenerated: false },
    { field: "ResourcePayGroup", type: "Selection", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "LTF", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 2, atLeastOne: false, autoGenerated: false },
    { field: "STF", type: "Decimal", unique: false, mandatory: true, minValue: 0, maxValue: 2, atLeastOne: false, autoGenerated: false },
    { field: "Subcontractor", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "SkillProfile", type: "Selection", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "ResourcePayGroupRef", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
    { field: "SkillProfileRef", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
  ];

  const ResourceProfiles: cellProps[] = [
    { field: "ResourceProfileRef", type: "String(20)", unique: true, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Description", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "DriverType", type: "Selection", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "VehicleType", type: "Selection", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Loading", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Unloading", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Crew", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "CrewMandatory", type: "Boolean", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false }, //check here
    { field: "DriverTypeRef", type: "String(20)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
    { field: "VehicleTypeRef", type: "String(20)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
  ];

  const Subcontractors: cellProps[] = [
    { field: "SubcontractorRef", type: "String(20)", unique: true, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Name", type: "String(35)", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Description", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
  ];

  const SubcontractorDepots: cellProps[] = [
    { field: "Depot", type: "List", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "Subcontractor", type: "List", unique: false, mandatory: true, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: false },
    { field: "DepotRef", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
    { field: "SubcontractorRef", type: "String(100)", unique: false, mandatory: false, minValue: null, maxValue: null, atLeastOne: false, autoGenerated: true },
  ];






}

function getSheetNames() {
  const sheetNames = [
    "Depots",
    "ProductHierarchy",
    "Products",
    "ServiceTypes",
    "Skills",
    "SkillGroups",
    "SkillProfiles",
    "ProductServiceSkillTime",
    "VehicleTypes",
    "PayRates",
    "PayGroups",
    "DriverTypes",
    "ResourceProfiles",
    "Subcontractors",
    "SubcontractorDepots",
    "Drivers",
    "Vehicles",
    "DepotRoutesRCTs",
    "ServiceLevels",
    // "AdditionalServices",
    "KnownLocations",
    "KnownLocationTypes",
    "CustomerAccounts",
    "BrandingProfiles",
    "Supervisors",
    "WorkflowFragments",

    //Not Found on sheet
    // "ServiceProfiles",
    // "ServiceDays",
  ];
  return sheetNames;
}

export { getDataSet, getSheetNames, getNewDataSet };
